import { provideAsmScopesViews } from '@asm/components-scopes/providers/provide-asm-scopes-views';
import { provideAsmCoreViews } from '@asm/components-core/providers/provide-asm-core-views';
import { provideAsmDashboardsViews } from '@asm/components-dashboards/providers/provide-asm-dashboards-views';
import { provideAsmEngagementsViews } from '@asm/components-engagements/providers/provide-asm-engagements-views';
import { provideAsmUsageViews } from '@asm/components-usage/providers/provide-asm-usage-views';
import { provideAsmCollaborationViews } from '@asm/components-collaboration/providers/provide-asm-collaboration-views';
import { provideAsmSearchViews } from '@asm/components-search/providers/provide-asm-search-views';
import { provideAsmAssetsViews } from '@asm/components-assets/providers/provide-asm-assets-views';
import { provideAsmAutomationViews } from '@asm/components-automation/providers/provide-asm-automation-views';
import { provideAsmIntegrationsViews } from '@asm/components-integrations/providers/provide-asm-integrations-views';
import { provideAsmTableViews } from '@asm/components-table/providers/provide-asm-table-views';
import { TypeService, ViewService } from '@sol/components';

export function provideAsmViews(viewService: ViewService, typeService: TypeService): void {
  provideAsmScopesViews(viewService, typeService);
  provideAsmCoreViews(viewService, typeService);
  provideAsmDashboardsViews(viewService, typeService);
  provideAsmEngagementsViews(viewService, typeService);
  provideAsmUsageViews(viewService, typeService);
  provideAsmCollaborationViews(viewService, typeService);
  provideAsmSearchViews(viewService, typeService);
  provideAsmAssetsViews(viewService, typeService);
  provideAsmAutomationViews(viewService, typeService);
  provideAsmIntegrationsViews(viewService, typeService);
  provideAsmTableViews(viewService, typeService);
}
